import {
    BackspaceOutlined as BackspaceOutlinedIcon,
    DeleteForeverOutlined as DeleteForeverOutlinedIcon,
    EditTwoTone as EditTwoToneIcon,
    Search as SearchIcon,
    VisibilityOutlined as VisibilityOutlinedIcon
} from '@material-ui/icons';
import {
    Button, Card, CardContent, Input, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead,
    TablePagination, TableRow, Tooltip
} from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import React, { Component } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';

class TipoVeiculoList extends Component {
    state = {
        tiposveiculos: [],
        totalItems: 0,
        page: Number(sessionStorage.getItem('tipoveiculoPage')) || 0,
        rowsPerPage: Number(sessionStorage.getItem('tipoveiculoRowsPerPage')) || 10,
        searchFilter: JSON.parse(sessionStorage.getItem('tipoveiculoSearchFilter')) || {
            desctipoveiculo: '',
            situacaoInativoFilter: ANAO
        }
    };

    estilo = {
        redText: { color: 'red' },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center'
        },
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30
    };

    constructor(props) {
        super(props);
    };

    /* Carregamento inicial */
    async componentDidMount() {
        this.loadTiposVeiculo();
    };

    componentDidUpdate(prevProps, prevState) {
        const { searchFilter, page, rowsPerPage } = this.state;

        if (prevState.searchFilter !== searchFilter) {
            sessionStorage.setItem('tipoveiculoSearchFilter', JSON.stringify(searchFilter));
        }
        if (prevState.page !== page) {
            sessionStorage.setItem('tipoveiculoPage', page);
        }
        if (prevState.rowsPerPage !== rowsPerPage) {
            sessionStorage.setItem('tipoveiculoRowsPerPage', rowsPerPage);
        }
    }

    componentWillUnmount() {
        sessionStorage.removeItem('tipoveiculoSearchFilter');
        sessionStorage.removeItem('tipoveiculoPage');
        sessionStorage.removeItem('tipoveiculoRowsPerPage');
    }

    /* Carrega tipos veículo */
    loadTiposVeiculo = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;
        const { desctipoveiculo, situacaoInativoFilter } = searchFilter;

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        if (desctipoveiculo) {
            params += `&DESCTIPOVEICULO=_like_${desctipoveiculo}`;
        }

        if (situacaoInativoFilter === ASIM || situacaoInativoFilter === ANAO) {
            params += `&INATIVO=${situacaoInativoFilter}`;
        }

        try {
            const response = await api.get('/tipoveiculo' + params);

            console.log('DADOS RETORNADOS DO BACKEND:', response.data);

            this.setState({
                tiposveiculos: response.data.data || [],
                totalItems: parseInt(response.data.info && response.data.info.totalrecords, 10) || 0
            });
        } catch (error) {
            console.error('Erro ao carregar tipos de veículos:', error);
            this.setState({
                tiposveiculos: [],
                totalItems: 0
            });
        }
    };

    /* Escolha de um registro para exclusão */
    handleSelectItem = (id) => {
        this.setState({ selectedId: id });
    };

    /* Deleta tipo veículo */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/tipoveiculo/${id}`);
            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadTiposVeiculo();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
        }
    };

    /* Abre janela confirmação para exclusão */
    handleOpen = (codtipoveiculo) => {
        this.setState({ open: true });
        this.handleSelectItem(codtipoveiculo);
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Pesquisar filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;
        const searchFilter = { ...this.state.searchFilter, [name]: value.toUpperCase() };
        this.setState({ searchFilter });
    };

    /* Limpa Filtros na tela */
    limpaFiltros = () => {
        const searchFilter = {
            desctipoveiculo: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({ searchFilter, page: 0 }, () => {
            this.loadTiposVeiculo();
        });
    };

    /* Muda página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => this.loadTiposVeiculo());
    };

    /* Muda quantidade por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => this.loadTiposVeiculo());
    };

    /* pega rota base - recurso compartilhado entre módulos */
    getBaseRoute = () => {
        const { location } = this.props;
        const pathname = location?.pathname || '';

        if (pathname.startsWith('/front/')) {
            return '/front/tipoveiculo';
        }

        return '/frotas/tipoveiculo';
    };

    render() {
        const {
            messageAlert,
            open,
            openAlert,
            page,
            rowsPerPage,
            searchFilter,
            selectedId,
            totalItems,
            tiposveiculos
        } = this.state;
        const {
            addButton,
            redText
        } = this.estilo;
        const baseRoute = this.getBaseRoute();

        return (
            <div style={this.estilo}>
                <Paper
                    hover
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        padding: '10px 20px',
                        width: '100%',
                        gap: 15
                    }}
                >
                    <Input
                        autoFocus
                        id="desctipoveiculo"
                        name="desctipoveiculo"
                        onBlur={this.onInputBlur}
                        onChange={this.onChangeSearch}
                        placeholder="Tipo"
                        value={searchFilter.desctipoveiculo}
                        style={{ width: 200 }}
                    />

                    <Select
                        id="situacaoInativoFilter"
                        name="situacaoInativoFilter"
                        value={searchFilter.situacaoInativoFilter || ''}
                        onChange={this.onChangeSearch}
                        style={{
                            width: 100,
                            textAlign: 'center'
                        }}
                    >
                        <MenuItem
                            value={ANAO}
                            style={{ justifyContent: 'center' }}
                        >
                            Ativos
                        </MenuItem>

                        <MenuItem
                            value={ASIM}
                            style={{ justifyContent: 'center' }}
                        >
                            Inativos
                        </MenuItem>

                        <MenuItem
                            value={'T'}
                            style={{ justifyContent: 'center' }}
                        >
                            Todos
                        </MenuItem>
                    </Select>

                    <span style={{ display: 'inline-flex', gap: 5 }}>
                        <Tooltip
                            title="Procurar"
                            enterDelay={50}
                        >
                            <SearchIcon
                                onClick={() => this.loadTiposVeiculo()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer'
                                }}
                            />
                        </Tooltip>

                        <Tooltip
                            title="Limpar"
                            enterDelay={50}
                        >
                            <BackspaceOutlinedIcon
                                onClick={() => this.limpaFiltros()}
                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                style={{
                                    fontSize: 24,
                                    color: '#0000ee',
                                    cursor: 'pointer'
                                }}
                            />
                        </Tooltip>
                    </span>

                    <div style={{ flex: 1 }} />

                    <Button
                        component={Link}
                        to={`${baseRoute}/novo`}
                        variant="contained"
                        color="primary"
                        style={addButton}
                    >
                        Novo
                    </Button>
                </Paper>

                <br />

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">Código</TableCell>

                                            <TableCell align="center">Descrição</TableCell>

                                            <TableCell align="center">Ações</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {tiposveiculos.map(tipoveiculo => (
                                            <TableRow
                                                hover
                                                key={tipoveiculo.codtipoveiculo}
                                            >
                                                <TableCell
                                                    align="center"
                                                    style={(tipoveiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {tipoveiculo.codtipoveiculo}
                                                </TableCell>

                                                <TableCell
                                                    align="center"
                                                    style={(tipoveiculo.inativo === ASIM) ? redText : {}}
                                                >
                                                    {tipoveiculo.desctipoveiculo}
                                                </TableCell>

                                                <TableCell align="center">
                                                    <Tooltip
                                                        title="Editar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`${baseRoute}/${tipoveiculo.codtipoveiculo}`}>
                                                            <EditTwoToneIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Visualizar"
                                                        enterDelay={50}
                                                    >
                                                        <Link to={`${baseRoute}/${tipoveiculo.codtipoveiculo}/view`}>
                                                            <VisibilityOutlinedIcon
                                                                onMouseEnter={(e) => e.currentTarget.style.color = '#1976d2'}
                                                                onMouseLeave={(e) => e.currentTarget.style.color = '#0000ee'}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#0000ee',
                                                                    marginRight: 6
                                                                }}
                                                            />
                                                        </Link>
                                                    </Tooltip>

                                                    <Tooltip
                                                        title="Excluir"
                                                        enterDelay={50}
                                                    >
                                                        <DeleteForeverOutlinedIcon
                                                            onMouseEnter={(e) => e.currentTarget.style.color = 'red'}
                                                            onMouseLeave={(e) => e.currentTarget.style.color = ''}
                                                            onClick={() => this.handleOpen(tipoveiculo.codtipoveiculo)}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    count={totalItems}
                    page={page}
                    onPageChange={this.handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    rowsPerPageOptions={[10, 50, 100, 200]}
                    labelRowsPerPage="Registros por página"
                />

                <DeleteConfirmationModal
                    open={open}
                    handleClose={() => this.handleClose()}
                    itemId={selectedId}
                    message={"Confirma exclusão do tipo de veículo " + selectedId + '?'}
                    handleDelete={() => this.handleDelete(selectedId)}
                />

                <AlertInformation
                    open={openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={messageAlert}
                />
            </div >
        );
    }
}

export default TipoVeiculoList;